import { call, put, takeLatest } from "redux-saga/effects";
import { authAction } from "../actions/authActions.ts";
import {
  setAuthData,
  setAuthFailed,
  setAuthLoading,
} from "../slices/authSlice.ts";
import { authApi } from "../../services/authService.ts";
import { transformAuthData } from "../../utils/transforms.ts";
import {
  setCurrentAuthenticatedUser,
  setUserIsSuperUser,
  setUserIsStaff,
  setUserIsGuest,
  setUserClient,
  setUserOwner,
  setUserPermissions,
  setUserClientHubUrl,
  setUserClientInsightsUrl,
} from "../slices/userInfoStore.ts";

function* fetchAuthSaga() {
  try {
    yield put(setAuthLoading());
    const authResponse = yield call(authApi);
    yield put(setAuthData(transformAuthData(authResponse)));
    yield put(setCurrentAuthenticatedUser(authResponse?.email));
    yield put(setUserIsSuperUser(authResponse?.is_admin));
    yield put(setUserIsStaff(authResponse?.is_staff));
    yield put(setUserIsGuest(!authResponse?.is_staff));
    yield put(setUserPermissions(authResponse?.permissions));
    const clientDetails = authResponse?.clientOwnerDetails;
    if (clientDetails && clientDetails.length > 0) {
      yield put(setUserClient(clientDetails[0].client.client_name));
      // set client hub and insights urls
      yield put(
        setUserClientHubUrl(clientDetails[0].client.url_client_hub ?? null),
      );
      yield put(
        setUserClientInsightsUrl(
          clientDetails[0].client.url_client_insights ?? null,
        ),
      );
      if (clientDetails[0].owner) {
        yield put(setUserOwner(clientDetails[0].owner.owner_name));
      } else {
        yield put(setUserOwner(null));
      }
    } else {
      yield put(setUserClient(null));
      yield put(setUserOwner(null));
      // clear hub / insights urls when no client
      yield put(setUserClientHubUrl(null));
      yield put(setUserClientInsightsUrl(null));
    }
  } catch (error: any) {
    // Surface the failure so Login can show it — a silent failure here used
    // to leave the app stuck in LOADING with no explanation.
    console.error("An error encountered during login process. ", error);
    const status = error?.response?.status;
    const message = status
      ? `Couldn't load your user profile (error ${status}). Please try again.`
      : "Couldn't reach the sign-in service. Check your connection and try again.";
    yield put(setAuthFailed(message));
  }
}

function* watchFetchAuthAction() {
  yield takeLatest(authAction.type, fetchAuthSaga);
}

export { watchFetchAuthAction };
